import {RouteContext} from "./RouteContext";
import {Button, Input, Label, makeStyles, useId} from "@fluentui/react-components";
import {useBoolean, useError, useInputString, useUndefined} from "../../type/States";
import {AdminSignInValueObject} from "../../model/vo/admin/AdminSignInValueObject";
import {useCallback, useEffect} from "react";
import {AdminSignInDataTransferObject} from "../../model/dto/admin/AdminSignInDataTransferObject";
import {AdminSignInIO} from "../../io/admin/AdminSignInIO";
import {Column} from "./common/Layout";


type SignInPageProps = RouteContext & {

}

const useStyles = makeStyles({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '240px',
        maxWidth: '480px',
    },
})

export default function SignInPage(props: SignInPageProps) {
    const styles = useStyles()
    const emailInputId = useId('sign-in-email')
    const emailState = useInputString('')
    const passwordInputId = useId('sign-in-password')
    const passwordState = useInputString('')
    const isFetching = useBoolean(false)
    const adminSignInState = useUndefined<AdminSignInValueObject>()
    const adminSignInErrorState = useError()

    useEffect(() => {
        if (adminSignInState.value !== undefined) {
            document.location.reload()
        }
    }, [adminSignInState.value])

    const onSignInClick = useCallback(() => {
        isFetching.setTrue()

        const dto: AdminSignInDataTransferObject.Post = {
            email: emailState.value,
            password: passwordState.value,
        }
        AdminSignInIO.post(dto)
            .then(adminSignInState.setDefinedValue)
            .catch(adminSignInErrorState.setValue)
    }, [emailState.value, passwordState.value])

    return <>
        <adminSignInErrorState.Dialog
            {...props}
            onDismiss={isFetching.setFalse}
        />
        <Column
            className={styles.root}
            gap={'16px'}>
            <Column>
                <Label
                    htmlFor={emailInputId}
                    disabled={isFetching.value}>
                    이메일
                </Label>
                <Input
                    id={emailInputId}
                    value={emailState.value}
                    onChange={emailState.onChange}
                    disabled={isFetching.value}
                    type={'email'} />
            </Column>
            <Column>
                <Label
                    htmlFor={passwordInputId}
                    disabled={isFetching.value}>
                    비밀번호
                </Label>
                <Input
                    id={passwordInputId}
                    value={passwordState.value}
                    onChange={passwordState.onChange}
                    disabled={isFetching.value}
                    type={'password'} />
            </Column>
            <Column>
                <Button
                    appearance={'primary'}
                    disabled={emailState.value.length === 0 || passwordState.value.length === 0 || isFetching.value}
                    onClick={onSignInClick}>
                    로그인
                </Button>
            </Column>
        </Column>
    </>
}